import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from 'features/shared/layout/header/Header';
import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Ets2AffidavitDetailSection from '../sections/Ets2AffidavitDetailSection';

interface RouteParams { ets2AffidavitId: string; }

const Ets2AffidavitDetailPage = () => {
  const { ets2AffidavitId } = useParams<RouteParams>();
  const { t } = useTranslation('shared\\moduleNames');

  return (
    <>
      <Header
        title={t('ets2AffidavitDetailPage.title')}
        includeBreadcrumbs
        links={[{ text: t('ets2Affidavits.title'), to: '/ets2-affidavit' }]}
      />
      <ModuleContent>
        {ets2AffidavitId && (
          <Ets2AffidavitDetailSection ets2AffidavitId={ets2AffidavitId} />
        )}
      </ModuleContent>
    </>
  );
};

export default Ets2AffidavitDetailPage;